import { createActions } from 'redux-actions';

export const {
  getAllPerformers,
  getAllPerformersSuccess,
  getAllPerformersFailure,
} = createActions(
  'GET_ALL_PERFORMERS',
  'GET_ALL_PERFORMERS_SUCCESS',
  'GET_ALL_PERFORMERS_FAILURE'
);
